module.exports = __webpack_public_path__ + "img/Avatar-72.3eb0a60c.svg";